import router from '@/router';
import store from '@/store';
import Swal from 'sweetalert2';
import mitt from 'mitt';

const EventBus = mitt();

export const UNAUTHORIZED_RESPONSE_INTERCEPTOR = [
  response => response,
  error => {
    if (!error.response) {
      // Network or connection error handled silently
      return Promise.reject(error);
    }

    const status = error.response.status;
    const suppressErrorModal = error.config?.suppressErrorModal === true;

    if (status === 401) {
      store.dispatch('account/logout');
      router.push('/acessar');
      return Promise.resolve(error.response);
    }

    if (suppressErrorModal) {
      EventBus.emit('spinner-stop');
      return Promise.reject(error);
    }

    if (status === 403) {
      Swal.fire('Sem permissão', 'Você não tem acesso a este recurso.', 'warning');
      router.push('/');
      return Promise.resolve(error.response);
    } else if (status === 500) {
      EventBus.emit('spinner-stop');
      Swal.fire({
        title: '<strong>Erro interno do servidor</strong>',
        icon: 'error',
        html: `Ocorreu um erro inesperado em nossos servidores.<br><br>
          <strong>O que fazer:</strong><br>
          • Tente novamente em alguns instantes<br>
          • Se o problema persistir, entre em contato com o suporte<br><br>
          <strong>Suporte:</strong><br>
          📞 (79) 3021.0022<br>
          ✉️ atendimento@pagcerto.com.br`,
        confirmButtonText: 'Entendi',
        footer: '<small>Código do erro: 500 - Internal Server Error</small>',
      });
      return Promise.resolve(error.response);
    } else if (status === 422) {
      return Promise.resolve(error.response);
    } else if (status >= 400 && status < 500) {
      EventBus.emit('spinner-stop');
      const errorTitle = status === 404 ? 'Recurso não encontrado' : 'Erro na solicitação';
      const errorMessage =
        status === 404
          ? 'O recurso solicitado não foi encontrado.'
          : 'Houve um problema com a sua solicitação.';

      Swal.fire({
        title: errorTitle,
        text: `${errorMessage} Tente novamente ou entre em contato com o suporte se o problema persistir.`,
        icon: 'error',
        confirmButtonText: 'Entendi',
        footer: `<small>Código do erro: ${String(status || '').replace(/[<>&"']/g, '')}</small>`,
      });
      return Promise.resolve(error.response);
    } else {
      EventBus.emit('spinner-stop');
      Swal.fire({
        title: 'Erro de conexão',
        text: 'Não foi possível conectar com o servidor. Verifique sua conexão e tente novamente.',
        icon: 'error',
        confirmButtonText: 'Tentar novamente',
        footer: `<small>Código do erro: ${String(status || 'Desconhecido').replace(/[<>&"']/g, '')}</small>`,
      });
      return Promise.resolve(error.response);
    }
  },
];

export const REQUEST_TOKEN_INTERCEPTOR = [
  config => {
    config.headers['Authorization'] = 'Bearer ' + store.getters['account/token'];
    return config;
  },
  error => Promise.reject(error),
];
